import { Component } from '@angular/core';
import { SubNavItem } from '../components/sub-navigation/sub-navigation.component';

@Component({
  selector: 'bwc-professions',
  templateUrl: './professions.component.html',
  styleUrls: ['./professions.component.scss'],
})
export class ProfessionsComponent {
  subNavItems: SubNavItem[] = [
    { label: 'professions.sub_nav.for_you', route: '/profile-check/professions' },
    { label: 'professions.sub_nav.find', route: '/profile-check/professions/search' },
    { label: 'professions.sub_nav.saved', route: '/profile-check/professions/saved' },
  ];
}
